import { useState } from 'react'
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { Typography } from '@mui/material'
import { Button } from '../../buttons'
import './TextClamp.scss'
import { useI18n } from '@ggs/i18n'

/**
 * @typedef {object} TextClampProps
 * @property {string} htmlContent
 * @property {number} maxLines
 */

/**
 * @param {TextClampProps} props
 * @return {JSX.Element}
 */
const TextClamp = ({ htmlContent, maxLines }) => {
  const { t } = useI18n()
  const [clamped, setClamped] = useState(true)

  return (
    <div className="text-clamp">
      <Typography
        component="div"
        className="text-clamp__content"
        style={{
          WebkitLineClamp: clamped ? maxLines : 'unset',
          height: clamped ? `calc(1rem * 1.5 * ${maxLines})` : 'unset'
        }}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
      <Button
        variant="text"
        onClick={() => setClamped((clamped) => !clamped)}
        buttonFields={{
          endIcon: clamped ? <KeyboardArrowDown /> : <KeyboardArrowUp />,
        }}
      >
        {clamped ? t('Read More') : t('Read Less')}
      </Button>
    </div>
  )
}

export default TextClamp
